import { Input } from 'antd';
import styled from 'styled-components';

const { Search } = Input;

export const StyledSearch = styled(Search)`
  width: 100%;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.palette.border};
  height: 36px;
  padding: 0 0 0 10px;
  background: ${props => props.theme.palette.background.light};

  &:hover {
    border: 1px solid ${props => props.theme.palette.primary.main};
  }

  &:focus-within {
    border: 1px solid ${props => props.theme.palette.primary.main};
    box-shadow: 0 0 2px ${props => props.theme.palette.primary.main};
  }

  .ant-input-wrapper {
    display: flex;
    height: 36px;
    margin-top: -1px;
  }

  .ant-input-affix-wrapper {
    padding: 0px;
  }

  .ant-input-prefix {
    margin-right: 10px;
    color: ${props => props.theme.palette.primary.main};
    font-size: 18px;
  }

  .ant-input-group-addon {
    display: none;
  }

  .ant-input-suffix {
    margin-right: 10px;
    font-size: 15px;

    .ant-input-clear-icon {
      font-size: 15px;
    }
  }
`;
